<template>
  <b-button :variant="variant" :size="size" :class="buttonClass" :disabled="disabled" @click="onClick" :title="tooltip" v-b-tooltip.hover.bottom>
    <slot></slot>
  </b-button>
</template>

<script>
  export default {
    props: {
      size: {
        type: String,
        default: 'md',
      },
      variant: {
        type: String,
        default: 'primary',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      buttonClass: String,
      type: {
        type: String,
        default: 'delete', // could be remove
      },
      noTooltip: {
        type: Boolean,
        default: false,
      },
      buttonTitle: String,
      message: String,
    },
    data() {
      return {
        trans: trans,
      }
    },
    computed: {
      tooltip() {
        return this.buttonTitle || (!this.noTooltip ? this.title : null)
      },
      title() {
        return trans(this.type || 'delete')
      },
      msg() {
        return this.message || trans(this.type + '_confirm')
      },
    },
    methods: {
      onClick() {
        this.$bvModal.msgBoxConfirm(this.msg, {
          title: this.title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.title,
          cancelTitle: trans('cancel'),
        })
        .then(value => {
          if (value) {
            this.$emit('confirm')
          } else {
            this.$emit('cancel')
          }
        })
      }
    }
  }
</script>